import React from "react";
import "./Footer.css";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import footerLogo from "./HeroSection/assets/logo.png"; // Adjust the path/filename as needed
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      {/* Top Section: Logo + Columns of Links */}
      <div className="footer-top">
        <div className="footer-logo-container">
          <img
            src={footerLogo}
            alt="Upskillmeet Logo"
            className="footer-logo-image"
          />
        </div>

        <div className="footer-links-container">
          <div className="footer-column">
            <h4>COMPANY</h4>
            <Link to="/tnc">Terms & Conditions</Link>
            <Link to="/refund-policy">Refund & Cancellation Policy</Link>
            <Link to="/privacy-policy"> Privacy Policy</Link>
            <Link to="/customer-support">Customer Support</Link>
          </div>
          <div className="footer-column">
            <h4>SUPPORT</h4>
            <a href="/faq">FAQ</a>
            <a href="/customer-support">Contact</a>
            <a href="/blog">Blog</a>
          </div>
        </div>
      </div>

      {/* Social Icons */}
      <div className="footer-social">
        <a href="#">
          <FaFacebookF />
        </a>
        <a href="#">
          <FaXTwitter />
        </a>
        <a href="#">
          <FaInstagram />
        </a>
        <a href="#">
          <FaLinkedinIn />
        </a>
      </div>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <p>© 2023 Avanad Techproserve. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
